module.exports = __webpack_public_path__ + "static/img/weather_014.76595d1e.svg";